/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/4
 * @Version : 1.0
 * @Content : 仪表盘配置
 */
export default {
  common: {
    action: '动作',
    operation: '操作',
    startDate: '开始日期',
    endDate: '结束日期',
    input: '请输入',
    details: '查看详情',
    expireDate: '到期时间',
    robot: '机器人',
    status: '状态',
    all: '全部',
    today: '今天',
    yesterday: '昨天',
    lastWeek: '上周',
    lastThirty: '过去30天',
    echarts: '图表',
    back: '返回'
  },
  // 操作
  actions: {
    confirm: '确认',
    detail: '详情',
    cancel: '取消',
    delete: '删除 | 批量删除',
    modify: '修改',
    create: '创建',
    check: '校验',
    search: '搜索 | 查询列表 | 查询单个',
    clear: '清空 | 清空全部',
    more: '查看更多',
    login: '登录',
    logout: '登出',
    start: '开始',
    stop: '结束',
    bind: '绑定',
    unbind: '解绑',
    export: '导出',
    upload: '上传',
    retry: '重做',
    unknown: '未知'
  },
  // 消息列表
  message: {
    title: '消息列表',
    level: '级别',
    module: '模块',
    content: '内容',
    status: '告警状态',
    time: '时间',
    date: '发布日期',
    levels: {
      all: '全部',
      info: '信息',
      warn: '警告',
      error: '错误',
      fatal: '致命'
    },
    statuss: {
      all: '全部',
      new: '未确认',
      confirmed: '已确认'
    }
  },
  // 操作日志
  logger: {
    title: '操作日志',
    module: '业务模块',
    user: '用户',
    time: '日志时间',
    desc: '日志描述'
  },
  // 订单管理
  order: {
    title: '订单管理',
    payPlatform: ['支付宝', '微信', 'PayPal', '兑换卡'],
    orderStatus: ['未支付', '已支付', '支付失败', '已取消', '待支付'],
    number: '订单编号',
    desc: '订单明细',
    time: '订单时间',
    payTime: '付款时间',
    type: '付款方式',
    status: '订单状态',
    cost: '费用',
    all: '全部订单',
    input: '输入订单号搜索...',
    pay: '支付',
    billing: '开票状态',
    billingStatus: ['未开票', '申请中', '已开票', '开票'],
    details: '订单详情',
    summary: '订单概要',
    viewCardPack: '查看卡包',
    detail: {
      number: '子订单号',
      type: '产品类型',
      detail: '产品详情',
      cost: '费用（元）',
      typeValue: '续费 | 新购',
      time: '订阅时间：{n}个月',
      total: '总计费用',
      prodName: '商品名称',
      prodAuthor: '作者',
      prodTag: '标签',
      prodVersion: '当前版本',
      prodVersionTime: '当前版本更新时间'
    },
    agent: '合作伙伴',
    agentTh: ['推广码', '公司名称', '公司地址', '联系电话', '折扣'],
    dis: '{dis}折'
  },
  // 购买
  purchase: {
    card: '兑换卡支付只能购单台设备',
    steps: {
      title1: '订单填写',
      title2: '订单确认',
      title3: ['支付成功', '支付失败', '取消订单', '支付中...'],
      license: '许可信息 | 产品信息',
      bind: '当前绑定的用户',
      count: '数量',
      purchaseTime: '购买时间',
      origPrice: '市场价',
      dctPrice: '折扣价'
    },
    step1: {
      title: '购买',
      addRenewTitle: '选择添加续费实例',
      next: '提交订单',
      addRenew: '添加续费',
      addRobot: '新增一个机器人',
      bind: '新许可，未绑定',
      month: '{n}个月',
      proCodeErrTips: '请检查确认您输入的推荐码正确无误且未过期。每项只能使用一个推荐码。',
      proCodeTips: '您选择了使用推荐码，但并未应用，点击‘继续’，将会以原价支付，是否继续？',
      popUps: {
        0: '请确认您购买的礼包',
        1: '低至',
        2: '元',
        3: '原价',
        4: '点击选择支付方式',
        5: '勾选以输入合作伙伴推荐码',
        6: '应用',
        7: '请输入推荐码',
        8: '合作伙伴价'
      }
    },
    step2: {
      next: '确认订单',
      paymentMethod: '付款方式',
      sub: '（订阅）',
      name: '机器名称：',
      deadline: '订阅期限：',
      type: '购买类型：',
      typeValue: '续费 | 购买'
    },
    step3: {
      next: '确认支付'
    },
    step4: {
      payment: ['支付成功', '支付失败', '取消订单', ''],
      welcome: '欢迎使用iS-RPA！',
      details: '订单详情',
      instance: '查看实例'
    },
    info: {
      discount: '折扣：',
      payable: '应付款：',
      marketPrice: '市场价：',
      invoice: '如需要发票，请由此通道付款，我们将发票以邮件形式发送至您的邮箱',
      license: '许可证在每个结算周期进行自动续期',
      agree: '我已阅读并同意',
      protocol: '艺赛旗RPA用户许可协议'
    }
  }
}
